import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { loadActiveRole } from "../../global-states/session/load-active-role";
import { AsyncPipe } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { BehaviorSubject, Observable } from "rxjs";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { SelectModule } from "primeng/select";
import { ICompany } from "../../models/i-company";
import { sessionStateServiceInjectionToken } from "../../global-states/session/session-state-service-injection-token";
import { ISessionStateService } from "../../global-states/session/i-session-state.service";
import { companyRestClientInjectionToken } from "../../rest-clients/company/company-rest-client-injection-token";
import { ICompanyRestClient } from "../../rest-clients/company/i-company-rest.client";
import { licenseRestClientInjectionToken } from "../../rest-clients/license/license-rest-client-injection-token";
import { ILicenseRestClient } from "../../rest-clients/license/i-license-rest.client";
import { IPage } from "@zaeper/communication-lib";
import {
	quickAccessResourcesResolverInjectionToken
} from "../../routing/resolvers/session/quick-access-resources-resolver-injection-token";
import { IQuickAccessResourcesResolver } from "../../routing/resolvers/session/i-quick-access-resources.resolver";

@Component({
	selector: "app-switch-company-modal",
	templateUrl: "./switch-company-modal.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [AsyncPipe, FormsModule, SelectModule]
})
export class SwitchCompanyModalComponent {
	public readonly activeCompany$: Observable<ICompany | null>;
	public readonly companies$: BehaviorSubject<ICompany[]> = new BehaviorSubject<ICompany[]>([]);

	constructor(
		@Inject(sessionStateServiceInjectionToken) private readonly _sessionStateService: ISessionStateService,
		@Inject(companyRestClientInjectionToken) private readonly _companyRestClient: ICompanyRestClient,
		@Inject(licenseRestClientInjectionToken) private readonly _licenseRestClient: ILicenseRestClient,
		@Inject(quickAccessResourcesResolverInjectionToken) private readonly _quickAccessResourcesResolver: IQuickAccessResourcesResolver,
		private readonly _dynamicDialogRef: DynamicDialogRef
	) {
		this.activeCompany$ = this._sessionStateService.activeCompany$;
		this._loadCompanies();
	}

	public switchToCompany(company: ICompany): void {
		const isOtherCompany: boolean = this._sessionStateService.getActiveCompany()?.id !== company.id;
		this._sessionStateService.setActiveCompany(company);
		void loadActiveRole(this._sessionStateService, this._companyRestClient, company.id);
		if (isOtherCompany) {
			// the clouds belong to the company, so its clouds, groups and receivers replace the old ones
			this._quickAccessResourcesResolver.reloadForActiveCompany();
		}
		this._licenseRestClient.getLicenseByCompany(company.id).then(license => {
			this._sessionStateService.setActiveLicense(license);
		});
		this._dynamicDialogRef.close();
	}

	private _loadCompanies(): void {
		this._companyRestClient.getCompanyPage({ pageNumber: 0, pageSize: 100 }).then((page: IPage<ICompany>) => {
			this.companies$.next(page.records);
		});
	}
}
